import React, {useState, useEffect} from 'react';
const $ = require('jquery');
import {useSelector} from 'react-redux';
import * as AuthService from '../../services/auth';
import {ContentHeader} from '@components';
import TableCrItem from './report/TableCrItem';
import ModalItem from './modal/ModalItem';
import Modal from 'react-bootstrap/Modal';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
export default function Report() {
  const user = useSelector((state: any) => state.auth.currentUser);
  const [showMd, setShowMd] = useState(false);
  const [show, setShow] = useState(false);
  const [dropdowns, setDropdowns] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    downloadWaitMe(null, "");
    downloadDropdownWs(user.ID_EMP);
    downloadCrWs();
  }, []);

  const downloadCrWs = async () => {
    try {
      const show = await AuthService.downloadCrWs();
      setShow(show.value);
    } catch (error) {}
  };

  const hideModal = () => {
    // $('#exampleModal').modal('hide');
    setShowMd(false);
  };

  const downloadDropdownWs = async (staffid: string) => {
    try {
      const dropdowns = await AuthService.downloadDropdownCar(`${staffid}?type=A`);
      console.log("HEHE");
      console.log(dropdowns);
      if (dropdowns.error) throw 'timeout';

      if (Object.keys(dropdowns).length !== 0) {
        console.log(dropdowns);
        setDropdowns(dropdowns);
      }
    } catch (error) {
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const toggleModal = (item: any) => {
    downloadDropdownWs(item.staffid)
    // $('#exampleModal').modal('toggle');
    setShowMd(!showMd);
    setItem(item);
  };

  const onRefresh = async (planid: any) => {
    await downloadWaitMe(planid, "");
    console.log('MOO-RELOAD TABLE FIN');
  };

  const setPageHandle = (page: number) => {
    setPage(page);
  };

  const downloadWaitMe = async (planid: any, date : string) => {
    try {
      setLoading(true);
      console.log('MOO-RELOAD TABLE START');
      console.log(`cr?${date}`);
      const data = await AuthService.downloadWaitMe(`cr?${date}`);
      console.log(data);
      setData(
        data.map((e) => ({
          ...e,
          enableShortcut: false,
          distanceTable: (e.distance / 1000).toFixed(2),
          distanceActualTable: (e.distanceActual / 1000).toFixed(2),
          totaCostActualTable: e.totaCostActual.toFixed(2),
          grandTotal: (e.totaCostActual + e.totalExpend).toFixed(2)
        }))
      );
      if (planid !== null) {
        setItem(data.filter((e: any) => e.planid === planid)[0]);
      }
      setLoading(false);
    } catch (error: any) {
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };
  return (
    <div>
      <Modal
        show={showMd}
        className={'modal-fullscreen'}
        onHide={() => setShowMd(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>รายละเอียด</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalItem
            onRefresh={onRefresh}
            onHide={hideModal}
            item={item}
            mode={'read'}
            dropdowns={dropdowns}
          ></ModalItem>
        </Modal.Body>
      </Modal>
      <ContentHeader title="Report" />{' '}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <TableCrItem
                dropdowns={dropdowns.TYPE ? dropdowns.TYPE.DATA : []}
                loading={loading}
                show={show}
                onToggle={toggleModal}
                items={data}
                onSubmit={downloadWaitMe}
                onPageChange={setPageHandle}
                page={page}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
